import { useHistory } from "react-router-dom";

import useQuery from "hooks/useQuery";

import {
    DEFAULT_MENU_ITEM_EDITOR_TAB,
    MENU_ITEM_EDITOR_TABS,
} from "features/MenuItemEditor/constants";
import { MenuItemEditorTab } from "features/MenuItemEditor/types";

const isEditorTab = (value: string | undefined): value is MenuItemEditorTab =>
    MENU_ITEM_EDITOR_TABS.some((tab) => tab.key === value);

// Активный таб живёт в ?tab=; пишем через replace, чтобы «назад» браузера не листал табы.
export const useActiveTab = (): [MenuItemEditorTab, (tab: MenuItemEditorTab) => void] => {
    const history = useHistory();
    const { tab } = useQuery<{ tab?: string }>();

    const activeTab: MenuItemEditorTab = isEditorTab(tab)
        ? tab
        : DEFAULT_MENU_ITEM_EDITOR_TAB;

    const setActiveTab = (next: MenuItemEditorTab) => {
        const params = new URLSearchParams(history.location.search);
        params.set("tab", next);
        history.replace({ search: params.toString() });
    };

    return [activeTab, setActiveTab];
};
